import { Text } from '@chakra-ui/react';

const NoOptionsMessage = () => (
  <Text fontSize="14px" color="gray.500" textAlign="center" py={4}>
    No options found
  </Text>
);

export default NoOptionsMessage;
